import React from 'react';
import {
  Box,
  Flex,
  Stack,
  Text,
  Avatar,
  Divider,
  Icon,
  Badge,
  HStack,
  Image,
} from '@chakra-ui/react';
import { BsFillEnvelopeAtFill, BsFillTelephoneFill } from 'react-icons/all';
import { UsersContact } from '~/types/userscontact';
import logo from '~/assets/logo-service-green.png';

interface ContactUsCardsProps {
  contatoUsuario?: UsersContact;
  existeContatos?: boolean;
  possuiTelefone?: boolean;
}
export const ContactUsCards: React.VFC<ContactUsCardsProps> = ({
  contatoUsuario,
  existeContatos = true,
  possuiTelefone = true,
}) => {
  const colors = [
    '#80c1e5',
    '#f3af6a',
    '#66c1b0',
    '#a17bc6',
    '#f293a1',
    '#48CAE4',
    '#DA3BAD',
    '#FF8C05',
    '#81C56A',
    '#3071EF',
  ];
  const getColor = (index: number) => {
    return colors[index % colors.length];
  };

  return !(existeContatos && contatoUsuario) ? (
    <Box borderColor="gray.200" borderWidth="1px" borderRadius={8}>
      <Stack>
        <Stack backgroundColor="#FAFAFA" py="2" px="2">
          <Image src={logo} maxW="7rem" />
        </Stack>
        <Divider m="0 !important" />
        <Stack px="2" minHeight="40px" justifyContent="center">
          <Text size="sm">
            Entre em contato através de nossos canais de atendimento:
          </Text>
        </Stack>
        <Divider />
        <HStack gridGap={1} pb="2" px="2" minHeight="40px">
          <Icon as={BsFillEnvelopeAtFill} fontSize="sm" />
          <Text color="#5b8af0" textDecoration="underline">
            positivoasaservice@positivo.com.br
          </Text>
        </HStack>
      </Stack>
    </Box>
  ) : (
    <Box borderColor="gray.200" borderWidth="1px" borderRadius={8}>
      <Stack>
        <Stack backgroundColor="#FAFAFA" py="2" px="2">
          <Flex flex="1" gap="4" alignItems="center" flexWrap="nowrap">
            <Avatar name={contatoUsuario?.nome} />
            <Stack px={3} gridGap={0} display="grid">
              <Text
                fontSize="lg"
                textTransform="capitalize"
                whiteSpace="nowrap"
                maxWidth="100%"
                overflow="hidden"
                textOverflow="ellipsis"
                fontWeight="bold"
                cursor="pointer"
                title={contatoUsuario?.nome}
              >
                {contatoUsuario?.nome}
              </Text>
              <Text
                color="purple.500"
                fontWeight="bold"
                fontSize="sm"
                margin="0px !important"
              >
                {contatoUsuario?.funcao}
              </Text>
            </Stack>
          </Flex>
        </Stack>
        <Divider m="0 !important" />
        <Stack px="2">
          {possuiTelefone && (
            <Text>
              <Icon as={BsFillTelephoneFill} fontSize="sm" marginRight={3} />
              {contatoUsuario?.telefone || '-'}
            </Text>
          )}
          <HStack gridGap={1}>
            <Icon as={BsFillEnvelopeAtFill} fontSize="sm" />
            <Text color="#5b8af0" textDecoration="underline">
              {contatoUsuario?.email}
            </Text>
          </HStack>
        </Stack>
        {/* <Divider /> */}
        <Stack px="2" py="2" minHeight="50px">
          <Text fontSize="small" fontWeight="bold">
            {!contatoUsuario?.segmentos_vendas.length
              ? ''
              : 'Segmentos de vendas:'}
          </Text>
          <Flex flexWrap="wrap" spacing="4" gap="4" alignItems="center">
            {contatoUsuario?.segmentos_vendas.length ? (
              contatoUsuario?.segmentos_vendas.map(
                (seg: string, index: number) => {
                  return (
                    <Badge
                      backgroundColor={getColor(index)}
                      px={2}
                      py={1}
                      borderRadius="10"
                      w="fit-content"
                      textAlign="center"
                      fontSize="10px"
                      marginRight={2}
                      mb={1}
                      textTransform="capitalize"
                      key={seg}
                      color="blackAlpha.900"
                      fontWeight={500}
                    >
                      {seg}
                    </Badge>
                  );
                },
              )
            ) : (
              <Text>{!contatoUsuario?.segmentos_vendas.length ? '' : '-'}</Text>
            )}
          </Flex>
        </Stack>
      </Stack>
    </Box>
  );
};
